import React from 'react';
import classnames from 'classnames';
import scrollIntoView from 'scroll-into-view';
import WordmarkIcon from 'images/icons/logos/wordmark.svg?react-svg';
import { hidden, tablet_inline } from 'scy/display.mod.scss';
import margin from 'scy/margin.mod.scss';
import { valignMiddle } from 'scy/utils.mod.scss';
import {
  sansSerifRegular,
  fontSizeXS,
  letterSpacingM,
  uppercase
} from 'scy/text/styles.mod.scss';
import Login from '../../header/login';
import NavWrapper from '../../header/NavWrapper';
import styles from '../../header/navWrapper.mod.scss';
import landingPageStyles from './styles.mod.scss';

function scrollToValueProps(e, id) {
  e.preventDefault();
  const valuePropsSection = document.getElementById(id);
  scrollIntoView(valuePropsSection, { align: { top: 0, topOffset: -10 } });
}

export default function LandingPageTopNav({ valuePropsId, toggleRef }) {
  return (
    <NavWrapper toggleRef={toggleRef}>
      <div
        className={`${styles.logoContainer} ${
          landingPageStyles.wordmarkContainer
        }`}
      >
        <WordmarkIcon />
        <a
          className={classnames(
            hidden,
            tablet_inline,
            uppercase,
            fontSizeXS,
            sansSerifRegular,
            letterSpacingM,
            valignMiddle,
            margin.left_md
          )}
          href="#value-props"
          onClick={e => scrollToValueProps(e, valuePropsId)}
        >
          How It Works
        </a>
      </div>
      <div className={classnames(hidden, tablet_inline, 'col-md-4')}>
        <Login
          buttonProps={{ inverted: true, className: sansSerifRegular }}
          hideTrackIcon
        />
      </div>
    </NavWrapper>
  );
}
